/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_TitleInputs */

const en_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const de_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysen`)
};

const fr_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses`)
};

const es_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis`)
};

const it_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi`)
};

const nl_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses`)
};

const pl_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizy`)
};

const fi_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytiikka`)
};

const da_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser`)
};

const sv_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Analytics_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_title = /** @type {((inputs?: Analytics_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_title(inputs)
	if (locale === "fr") return fr_analytics_title(inputs)
	if (locale === "es") return es_analytics_title(inputs)
	if (locale === "it") return it_analytics_title(inputs)
	if (locale === "nl") return nl_analytics_title(inputs)
	if (locale === "pl") return pl_analytics_title(inputs)
	if (locale === "fi") return fi_analytics_title(inputs)
	if (locale === "da") return da_analytics_title(inputs)
	if (locale === "sv") return sv_analytics_title(inputs)
	return en_analytics_title(inputs)
});